import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SpiritImagePipe } from '../../../core/pipes/spiritImage';
import { SpiritTranslationPipe } from '../../../core/pipes/spiritTranslation';
import { CatalogTranslationPipe } from '../../../core/pipes/catalogTranslation';

const materialModules = [
  MatIconModule,
  MatButtonModule
]

const pipes = [
  DatePipe,
  SpiritImagePipe,
  SpiritTranslationPipe,
  CatalogTranslationPipe
]

@Component({
  selector: 'app-locker-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
  standalone: true,
  imports: [
    TranslateModule, ...materialModules, ...pipes
  ]
})
export class OrderComponent  implements OnInit {

  @Input() order: any = null;
  @Input() menu: any;

  constructor() { }

  ngOnInit(): void {
  }

  toFixed(n: number) {
    return n.toFixed(2);
  }

}
